import { useIntl } from "react-intl";

export type Values = Record<string, string | number>;

/** Kurzform für formatMessage (Texte immer aus dem Katalog) */
export function useT() {
  const intl = useIntl();
  return (id: string, v?: Values) => intl.formatMessage({ id }, v);
}
export type T = ReturnType<typeof useT>;
